import { createContext } from 'react';
import { AdvertBottomSheetContextType } from '#advertBottomSheet/contexts';

const AdvertBottomSheetContext = createContext<AdvertBottomSheetContextType>(null);

export { AdvertBottomSheetContext };
